import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_s6n7en723t: FaireCollectionEntity = {
  token: "pbc_s6n7en723t",
  type: "collection",
  name: "HEELS",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ecc9d4fba83b797d20147ad94b9641b812da5c2cf20d0e6ac9f717e1f05acea8.jpeg",
  itemCount: 12,
  description:
    "Find the perfect heel for any occasion—ideal for the office, a night out, and a jet-set resort getaway 🏢🥂🏖️\nFor styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes\n\n",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:30.962Z",
    importedBy: "entity-db-import-collections",
  },
};
